
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css'; // Import Quill styles

const modules = {
    toolbar: [
      ['clean'],
      [{ 'header': '1' }, { 'header': '2' }],
      [{ size: [] }],
      ['bold', 'italic', 'underline', 'strike', 'blockquote'],
      [{ 'indent': '-1' }, { 'indent': '+1' }]
    ],
    clipboard: {
      // toggle to add extra line breaks when pasting HTML:
      matchVisual: false,
    }
  };
  const formats = [
    'header', 'font', 'size',
    'bold', 'italic', 'underline', 'strike', 'blockquote'
  ];

const RtfEditor = ({ onChange, value }: { onChange: (html: string) => void, value: string }) => {
  const handleChange = (html: string) => {
    onChange(html);
  }
    return (
      <div>
        <ReactQuill
          theme={"snow"}
          onChange={handleChange}
          value={value}
          modules={modules}
          formats={formats}
          bounds={'.app'}
          placeholder=""
        />
      </div>
    );
}

export default RtfEditor;
